<nav
  class="fixed lg:ml-20 md:ml-20 lg:pr-20 md:pr-20 sm:ml-0 sm:pr-20 h-20 top-0 z-40 w-full bg-white border-b border-gray-200 dark:bg-gray-800 dark:border-gray-700"
  [ngClass]="{
    transitionOut: hidden,
    'lg:ml-52 md:ml-52 lg:pr-52 md:pr-52 transitionIn': !hidden
  }"
  (click)="handleClick()"
>
  <div class="flex px-3 py-3 lg:px-5 lg:pl-3 h-20">
    <div class="flex items-center justify-between w-full">
      <div class="flex items-center justify-start min-w-0">
        <button
          data-drawer-target="sidebar"
          data-drawer-toggle="sidebar"
          aria-controls="sidebar"
          type="button"
          class="inline-flex items-center p-2 text-sm text-gray-500 rounded-lg sm:hidden focus:outline-none dark:text-gray-400 shrink-0"
        >
          <img
            [src]="images.menuBurger"
            alt="menuBurger"
            height="22"
            width="22"
          />
        </button>

        @if (breadcrumb && breadcrumb.length > 0) {
          <nav id="breadcrumb" class="flex items-center pl-6 min-w-0" [ngClass]="{ transitionOut: hidden, transitionIn: !hidden }">
            @for (item of breadcrumb; track $index; let last = $last) {
              @if (item.url) {
                <a
                  [id]="'breadcrumb-item-' + $index"
                  [href]="item.url"
                  class="text-2xl font-bold sm:text-xl truncate min-w-8 primary-purple-text uppercase hover:underline"
                  [tooltip]="utilsService.visibleTooltip('breadcrumb-item-' + $index) ? getBreadcrumbLabel(item) : ''"
                  [visibleTooltip]="utilsService.visibleTooltip('breadcrumb-item-' + $index)"
                  [position]="TooltipPosition.BELOW"
                >
                  {{ getBreadcrumbLabel(item) }}
                </a>
              } @else {
                <span
                  [id]="'breadcrumb-item-' + $index"
                  class="text-2xl font-bold sm:text-xl truncate min-w-8 primary-purple-text uppercase"
                  [tooltip]="utilsService.visibleTooltip('breadcrumb-item-' + $index) ? getBreadcrumbLabel(item) : ''"
                  [visibleTooltip]="utilsService.visibleTooltip('breadcrumb-item-' + $index)"
                  [position]="TooltipPosition.BELOW"
                >
                  {{ getBreadcrumbLabel(item) }}
                </span>
              }
              @if (!last) {
                <span class="mx-3 text-2xl font-bold text-gray-400 shrink-0">&gt;</span>
              }
            }
          </nav>
        } @else if (breadcrumb === null) {
          <h1
            id="title"
            class="self-center text-2xl font-bold sm:text-xl whitespace-nowrap dark:text-white uppercase pl-6"
            [ngClass]="{ transitionOut: hidden, transitionIn: !hidden }"
          >
            {{ literalService.get(titleKey ?? 'sidebar.' + routeName) }}
          </h1>
        }
      </div>
      <div class="flex items-center gap-2 shrink-0">
        @if (serviceWizardService.active) {
          <nav id="wizardSteps" class="flex items-center gap-3 min-w-0">
            <ul class="steps">
              @for (step of serviceWizardService.steps; track step; let index = $index) {
                <li class="step px-2 text-xs" [ngClass]="{'step-active': serviceWizardService.isPreviousToCurrentStep(step) || step === serviceWizardService.step, 'font-bold': step === serviceWizardService.step}">
                  <span class="step-icon text-sm mb-1" [ngClass]="{'font-extrabold': step === serviceWizardService.step, 'font-semibold': step !== serviceWizardService.step}">
                    @if (serviceWizardService.isPreviousToCurrentStep(step)) {
                      <img [src]="images.check" alt="stepDone" class="w-3.5 h-3.5" />
                    }
                    @else {
                      {{ index + 1 }}
                    }
                  </span>
                  {{ literalService.get('services.wizard.' + serviceWizardService.stepLabelKey(step), true) }}
                </li>
              }
            </ul>
          </nav>
        }
        @else {
          <app-push-notifications></app-push-notifications>
          <app-user-profile [arrow]="arrow" [passwordModal]="changePasswordModalGeneral"></app-user-profile>
        }
      </div>
    </div>
  </div>
</nav>
<app-modal-change-password [id]="'changePasswordModalGeneral'" [modal]="changePasswordModalGeneral" [password]="password" [confirmPassword]="confirmPassword" [loading]="changingPassword" [hidden]="changePasswordModalGeneralShowed" [errors]="passwordErrors" (action)="changePassword($event)" />
